package com.kitco.metalynxscrapit.shared.domain.model

import kotlinx.serialization.Serializable

@Serializable
enum class Metal(val code: String) {
    Gold("AU"), Silver("AG"), Platinum("PT")
}
